import { useHistory } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import toast from 'react-hot-toast';

import SuccessImage from '@images/success.png';
import CopyLink from '@images/copyLinkRecentVoteIcon.svg';
import ButtonMighty from '@components/elements/ButtonMighty';
import InputText from '@components/elements/InputText';
import PollShareCard from '@components/modules/PollShareCard';

interface PollCreateSuccessPageProps {
  isEdit?: boolean;
  pollId: string;
  isPledge?: boolean;
}

const PollCreateSuccessPage: React.FC<PollCreateSuccessPageProps> = ({
  isEdit = false,
  pollId,
  isPledge = false,
}) => {
  const history = useHistory<any>();

  const shareUrl = `${window.location.origin.toString()}/poll/${pollId}`;

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 pt-16 pb-32 text-white bg-black">
      <img className="h-48" src={SuccessImage} alt="success" />

      <h2 className="mb-4 text-2xl text-center whitespace-pre">
        {`YOUR ${isPledge ? 'PLEDGE' : 'POLL'} HAS BEEN\n SUCCESSFULLY ${
          isEdit ? 'UPDATED' : 'CREATED'
        }.`}
      </h2>
      <p className="mb-8 text-center">Copy the link below to share</p>

      <div className="relative w-full mb-8">
        <CopyToClipboard
          text={shareUrl}
          onCopy={() => toast('Copied link to clipboard.')}
        >
          <img
            role="button"
            className="absolute p-2 transform -translate-y-1/2 rounded-md cursor-pointer right-2 top-1/2 hover:bg-magenta hover:bg-opacity-20"
            src={CopyLink}
            alt="copy"
          />
        </CopyToClipboard>
        <InputText value={shareUrl} className="w-full pr-12" />
      </div>

      <div className="w-full mb-8">
        <PollShareCard pollId={pollId} />
      </div>

      <div className="flex justify-center">
        <ButtonMighty
          disabled={false}
          loading={false}
          color="#8052FF"
          textColor="#29FF2E"
          borderColor="#29FF2E"
          margin="0"
          text={isPledge ? 'View Pledge' : `View Poll`}
          onClick={() => history.push(`/poll/${pollId}`)}
        />
      </div>
    </div>
  );
};

export default PollCreateSuccessPage;
